import { BASE_SIZE } from '../constants/contants';

export function pixelToRem(px: number, base = BASE_SIZE) {
  return px / base;
}
